import React, { Component } from "react";
import { Redirect } from 'react-router-dom'
import { API, Storage } from "aws-amplify";
import config from "../config";
import CarouselWidget from "./CarouselWidget";
import AuthorWidget from "./AuthorWidget";
import BlogContent from "./BlogContent";
import CommentsWidget from "./CommentsWidget";
import UserProfile from "./UserProfile";
import BlogWidget from "./BlogWidget";
import UpdateProfile from "./UpdateProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import EducationDetails from "./EducationDetails";
import AreasOfInterest from "./AreasOfInterest";
import ChangePassword from "./ChangePassword";
import moment from "moment";

export default class UserHome extends Component {

  constructor(props){
    super(props);

    this.state ={
      isLoading: true,
      isServerLoadComplete: false,
      view: "Blogs",
      blogs: []
    };
  }

  async componentDidMount(){
    if(!this.props.isAuthenticated){
      return;
    }
    try{
      const blogs = await this.blogs();
      this.setState({blogs: blogs});
      var userDetails = await this.getUserProfileFromServer();

      userDetails.profilePicUrl = await this.getProfileImage(userDetails.profilePic);
      this.setState({userProfile: userDetails, isServerLoadComplete: true});

    }catch(e){
      alert("UserHome.js says "+e);
    }

    this.setState( { isLoading: false, isServerLoadComplete: true } );
  }

  blogs(){
    return API.get("retnetindia", "/blogs");
  }

  async getUserProfileFromServer(){
    return await API.get("retnetindia", "/user/profile");
  }

  async getProfileImage(profilePic){
     var profilePicUrl = ""
     if(profilePic && profilePic.length > 0){
        profilePicUrl = await Storage.get(profilePic);
     }
     return profilePicUrl;
  }

  renderBlogsList = blogs => {

    if(!this.state.blogs){
      return (
        <p className="spinner-big"> Loading &nbsp;
            <i className="fa fa-circle-o-notch fa-spin"></i>
        </p>
      );
    }

    blogs.sort(function(blog1, blog2){
        var keyA = new Date(blog1.createdAt),
            keyB = new Date(blog2.createdAt);
        // Compare the 2 dates
        if(keyA < keyB) return 1;
        if(keyA > keyB) return -1;
        return 0;
    });

    var  blogWidgets = [];
    for(var i = 0 ; i < blogs.length; i++){
      blogWidgets.push(<BlogWidget key={"blog-"+i} blog={blogs[i]}
                              isAuthenticated={this.props.isAuthenticated}
                              userProfile={this.state.userProfile}
                              updateCaseOfTheMonth={this.props.updateCaseOfTheMonth}
                              getCaseOfTheMonth={this.props.getCaseOfTheMonth}
                              history={this.props.history}/>);
    }

    return(
      <div >
        {  blogWidgets }

      </div>
    );
  }



  renderLander = () => {
    return(
      <Redirect to='/login' />
    )
  }

  renderNotes(){
    if(!this.state.isServerLoadComplete){
        return(
          <section className="slice-sm sct-color-1">
                     <div className="profile">
                         <div className="container text-centre">
                             <div className="row cols-xs-space cols-sm-space cols-md-space ">
                                  <h3>Please wait while we load &nbsp;</h3>
                                  <i className="fa fa-spinner fa-spin fa-2x" ></i>
                             </div>
                             <div className="height-500">
                             </div>
                         </div>
                     </div>
          </section>
        );


    }

    return( this.state.blogs &&
            <section className="slice-sm sct-color-1">
                       <div className="profile">
                           <div className="container">
                               <div className="row cols-xs-space cols-sm-space cols-md-space">
                                   <div className="col-lg-3">
                                      <UserProfile  userProfile={this.state.userProfile} updateView={this.updateView}/>
                                   </div>

                                   <div className="col-lg-9">
                                       <div className="main-content">

                                            {this.renderView()}

                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
            </section>
    );
  }

  showAddBlogView = () => {
    this.updateView("AddBlog")
  }

  updateView = viewName => {
    this.setState({view: viewName});
  }

  renderView = () => {

    if(this.state.view === "Profile"){
      return this.renderEditProfile();
    }
    if(this.state.view === "Job"){
      return this.renderEditJobDetails();
    }
    if(this.state.view === "Education"){
      return this.renderEditEducationDetails();
    }
    if(this.state.view === "ChangePassword"){
      return this.renderChangePassword();
    }
    if(this.state.view === "AreasOfInterest"){
      return this.renderAreasOfInterest();
    }

    return this.renderBlogsList(this.state.blogs);
  }

  updateUserProfile = async profileDetails => {
    var newUserProfile = await API.put("retnetindia", "/user/profile", {
                            body: profileDetails
                          });
    newUserProfile.profilePicUrl = await this.getProfileImage(newUserProfile.profilePic);
    this.setState({userProfile: newUserProfile});
  }

  renderEditProfile = () => {
     return <UpdateProfile userProfile={this.state.userProfile}
              updateUserProfile={this.updateUserProfile}/>
  }

  renderEditJobDetails = () => {
     return <ProfessionalDetails userProfile={this.state.userProfile}
                                updateUserProfile={this.updateUserProfile}/>
  }

  renderEditEducationDetails = () => {
      return <EducationDetails userProfile={this.state.userProfile}
                              updateUserProfile={this.updateUserProfile}/>
  }

  renderAreasOfInterest = () => {
     return <AreasOfInterest userProfile={this.state.userProfile}
                              updateUserProfile={this.updateUserProfile} />
  }

  renderChangePassword = () => {
       return <ChangePassword userProfile={this.state.userProfile}
                        updateUserProfile={this.updateUserProfile}
                        logoutHandler={this.props.logoutHandler}/>
  }

  render(){
      return(
          <div>
          {this.props.isAuthenticated ? this.renderNotes()
                                      : this.renderLander()}
          </div>
      );
  }

}



// WEBPACK FOOTER //
// ./src/containers/UserHome.js